'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localizeFromKey = localizeFromKey;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This will localize the string if the localKey is provided.
 * @param  {[type]} obj                Object which contains localKey option
 * @param  {[type]} intl               Intl helper to get the localize message
 * @param  {[type]} nonLocalizeTextKey This is the key which contains non-localize string coming from backend
 *                                     its used in the absence of localKey
 * @return {[type]}                    Localize string
 */
function localizeFromKey(obj, intl) {
  var nonLocalizeTextKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';

  return _lodash2.default.has(obj, 'localeKey') ? intl.formatMessage({ id: obj.localeKey, defaultMessage: nonLocalizeTextKey }) : obj[nonLocalizeTextKey];
}

exports.default = {
  localizeFromKey: localizeFromKey
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/utils/localization/lib/index.js
// module id = 513
// module chunks = 4